import SpeedProvider from "./SpeedProvider";
import SpeedContext from "./context";

export default SpeedContext;
export { SpeedProvider };
